import React from "react";
import { useAthletes } from "../Hooks/index";
import { useLocation } from "react-router";
import { useEffect } from "react";
import DataTable from "../../../../Common/Components/DataTable";
import Loading from "../../../../Common/Components/Loading";
function AthletesList() {
  const { loading, getData, data } = useAthletes();
  const location = useLocation();

  useEffect(() => {
    getData(location && location.state && location.state.class_id);
  }, []);

  return (
    <div className="card">
      <div className="card-body">
        <DataTable
          loading={loading}
          heads={[
            {
              title: "نام  ",
              key: "fullname",
            },
            {
              title: "کدملی ",
              key: "national_code",
            },
            {
              title: "شماره موبایل ",
              key: "mobile",
            },
            {
              title: "کد پیگیری ",
              key: "trackingcode",
            },
          ]}
          list={data}
          data={data}
          textEmpty="ورزشکاری برای این کلاس وجود ندارد"
        />
      </div>
    </div>
  );
}

export default AthletesList;
